import "./EventPromoItem.scss";
import {
  CalendarBlankIcon,
  HideFor,
  InfoSmallIcon,
  Label,
  MapPinIcon,
  Picture,
} from "/App.Components";
import { EventPromoItemProps } from "/Models/Generated/EventPromoItemProps";
import cn from "classnames";

interface EventPromoItemExtendedProps extends EventPromoItemProps {
  isTopItem: boolean;
}

const EventPromoItem = ({
  label,
  date,
  heading,
  location,
  picture,
  href,
  isTopItem,
}: EventPromoItemExtendedProps) => (
  <>
    <HideFor desktop tablet desktopMedium desktopLargeUp>
      <div
        className={cn("event-promo-item-norad__divider", {
          "event-promo-item-norad__divider--no-top-margin": isTopItem,
        })}
      ></div>
    </HideFor>
    <a className="event-promo-item-norad" href={href}>
      <div className="event-promo-item-norad__image-container">
        {picture && (
          <Picture
            noAlt
            {...picture}
            pictureAspectRatio="DefaultSquareMobileRectangle"
            pictureBehaviour="Cover"
          />
        )}
      </div>
      <div className="event-promo-item-norad__content">
        {label && (
          <div className="event-promo-item-norad__label">
            <Label text={label} isExternal={false} compact />
          </div>
        )}
        {!label && <div className="event-promo-item-norad__no-label"></div>}
        <h3 className="event-promo-item-norad__heading">
          <span>{heading}</span>
        </h3>
        <div className="event-promo-item-norad__metadata-items">
          {date && <InfoSmallIcon text={date} icon={CalendarBlankIcon} />}
          {location && <InfoSmallIcon text={location} icon={MapPinIcon} />}
        </div>
      </div>
    </a>
  </>
);
export default EventPromoItem;
